import Icon from "./Icon"

const defaultTheme = {
  token: {
    fontFamily: `'Inter', sans-serif`,

    fontSizeBase: 14,
    fontSize: 14,

    fontSizeSM: 12,
    fontSizeLG: 16,

    fontWeightStrong: 500,

    fontSizeHeading1: 28,
    fontSizeHeading2: 24,
    fontSizeHeading3: 20,
    fontSizeHeading4: 18,

    lineHeightHeading1: 1.4,
    lineHeightHeading2: 1.4,
    lineHeightHeading3: 1.4,
    lineHeightHeading4: 1.4,
    lineHeightHeading5: 1.4,

    radiusBase: 12,
    controlRadius: 12,

    colorLinkHover: "#1448CB"
  },
  components: {
    Typography: {
      lineHeight: "20px"
    },
    Layout: {
      bodyBg: "#FFFFFF",
      headerBg: "#FFFFFF",
      headerPadding: "16px 32px"
    },
    Button: {
      borderRadius: 8,
      borderRadiusLG: 12,
      borderRadiusSM: 4,

      paddingInline: 8,
      paddingInlineLG: 12,

      controlHeight: 32,
      controlHeightLG: 40,
      controlHeightSM: 24,
      fontSize: 14,
      fontSizeLG: 14,
      fontSizeSM: 12,

      onlyIconSize: 20,
      onlyIconSizeLG: 20,
      onlyIconSizeSM: 20,

      fontWeight: 500,

      borderColorDisabled: "transparent",

      defaultShadow: ""
    },
    Input: {
      controlHeight: 40,
      controlHeightSM: 32,
      borderRadius: 12,
      borderRadiusSM: 8,
      paddingInline: 12,

      fontSizeIcon: 20
    },
    InputNumber: {
      controlHeight: 40,
      controlHeightSM: 32,
      borderRadius: 12,
      borderRadiusSM: 8,
      paddingInline: 12,

      fontSizeIcon: 20
    },
    Notification: {
      paddingMD: 12,
      paddingContentHorizontalLG: 12,
      borderRadiusLG: 12,
      marginXS: 4,
      colorText: "#7A7A83"
    },
    Modal: {
      fontWeightStrong: 500,
      borderRadiusLG: 24,
      padding: 16,
      paddingLG: 16,
      paddingMD: 16,
      paddingContentHorizontalLG: 16,
      lineHeightHeading5: 1.4,
      marginXS: 12,
      headerBg: "transparent"
    },
    Table: {
      fontWeightStrong: 400,
      headerBorderRadius: 12,
      lineHeight: 1.5,
      headerSplitColor: "transparent"
      //rowHoverBg: 'transparent',
    },
    Tooltip: {
      borderRadius: 8,
      paddingXS: 8,
      controlHeight: 24,
      fontSize: 12,
      lineHeight: 1.5
    },
    Tag: {
      fontSize: 14,
      borderRadiusSM: 12,
      defaultBg: "transparent"
    },
    Switch: {
      trackMinWidth: 32,
      trackHeight: 20,
      handleSize: 16
    },
    Select: {
      borderRadius: 8,
      borderRadiusLG: 12,
      borderRadiusSM: 12,
      controlPaddingHorizontal: 8,

      fontSizeLG: 14,

      optionActiveBg: "#F4F4F5",
      optionSelectedBg: "transparent",
      optionHeight: 40,
      optionLineHeight: "20px",
      optionPadding: "10px 8px"
    },
    Dropdown: {
      borderRadiusLG: 16,
      controlHeight: 40,
      borderRadiusSM: 12,
      controlItemBgHover: "#F4F4F5",
      controlItemBgActiveHover: "transparent",
      paddingXXS: 8
    },
    Radio: {
      radioSize: 20,
      dotSize: 14,
      colorBorder: "transparent",
      colorPrimaryBorder: "transparent"
    },
    Form: {
      //labelRequiredMarkColor: '#225AEA'
    },
    Alert: {
      defaultPadding: 12,
      withDescriptionPadding: 12,
      borderRadiusLG: 12,
      fontSizeLG: 14,
      lineHeight: "20px",
      fontSizeIcon: 20,
      marginXS: 4
    },
    Descriptions: {
      borderRadiusLG: 16,
      labelBg: "#FCFCFC",
      paddingLG: 16,
      padding: 12,
      lineHeight: "20px"
    },
    List: {
      itemPaddingSM: "8px 12px",
      borderRadiusLG: 12
    },
    Checkbox: {
      controlInteractiveSize: 20,
      borderRadiusSM: 4,
      lineHeight: "20px"
    },
    Segmented: {
      trackPadding: 1,
      borderRadius: 8,
      borderRadiusSM: 7,
      borderRadiusLG: 9,
      fontSizeLG: 14
    },
    Tabs: {
      horizontalItemGutter: 24,
      horizontalItemPadding: "8px 0 12px",
      horizontalMargin: "0 0 12px 0"
    }
  }
}

export const lightTheme = {
  token: {
    ...defaultTheme.token,

    colorPrimary: "#225AEA",
    colorLink: "#225AEA",
    colorSuccess: "#16895A",
    colorWarning: "#DF7009",
    colorError: "#D71313",
    colorErrorBorderHover: "#D71313",
    black: "#000000",

    colorText: "#27272A",
    colorTextBase: "#27272A",
    colorTextHeading: "#27272A",
    colorTextDescription: "#7A7A83",
    colorTextDisabled: "#A1A1AA",

    colorBgContainerDisabled: "#F4F4F5",

    colorBorder: "#E1E1E2",
    colorBorderSecondary: "#E1E1E2",

    colorTextPlaceholder: "#7A7A83",
    colorBgLayout: "#FFFFFF",
    colorSplit: "#E1E1E2",

    bgPrimary: "#F9FBFF"
  },
  components: {
    ...defaultTheme.components,
    Button: {
      ...defaultTheme.components.Button,
      primaryShadow:
        "0px 0px 0px 1px rgba(29, 79, 215, 0.96), 0px 1px 2px 0px rgba(30, 63, 173, 0.72)",
      //primaryShadow: '0 1px 2px 0 rgba(30, 63, 173, 0.72), 0 0 0 1px rgba(29, 79, 215, 0.96)',

      defaultHoverBorderColor: "#E1E1E2",
      defaultHoverBg: "#F4F4F5",
      defaultHoverColor: "#27272A",
      defaultActiveBorderColor: "#E1E1E2",
      defaultActiveBg: "#FFFFFF",
      defaultActiveColor: "#27272A",

      textHoverBg: "#F4F4F5",

      colorPrimaryHover: "#1448CB",
      colorPrimaryActive: "#1448CB",
      colorBgTextActive: "transparent",
      colorBgTextHover: "transparent"
    },
    Input: {
      ...defaultTheme.components.Input,
      hoverBg: "#F4F4F5",
      hoverBorderColor: "#E1E1E2",
      activeBorderColor: "#225AEA",
      colorIcon: "#7A7A83",
      colorIconHover: "#7A7A83",
      colorBgContainerDisabled: "#F4F4F5",
      colorTextDisabled: "#A1A1AA",
      errorActiveShadow: "0px 0px 0px 2px #FFDCDC"
    },
    InputNumber: {
      ...defaultTheme.components.InputNumber,
      hoverBg: "#F4F4F5",
      hoverBorderColor: "#E1E1E2",
      activeBorderColor: "#225AEA",
      colorIcon: "#7A7A83",
      colorIconHover: "#7A7A83",
      colorBgContainerDisabled: "#F4F4F5",
      colorTextDisabled: "#A1A1AA"
    },
    Notification: {
      ...defaultTheme.components.Notification,
      boxShadow: "1px 2px 4px 0px rgba(39, 39, 42, 0.08), 0 8px 25px 0 rgba(21, 30, 58, 0.12)"
    },
    Modal: {
      ...defaultTheme.components.Modal,
      colorBgMask: "rgba(39, 39, 42, 0.65)",
      titleColor: "#27272A",
      colorText: "#7A7A83"
    },
    Alert: {
      ...defaultTheme.components.Alert,
      colorInfo: "#7A7A83",
      colorInfoBg: "#F4F4F5",
      colorInfoBorder: "#F4F4F5",

      colorWarningBg: "#FFF5EA",
      colorWarningBorder: "#FFF5EA",

      colorErrorBg: "#FFF4F4",
      colorErrorBorder: "#FFF4F4"
    },
    Table: {
      ...defaultTheme.components.Table,
      headerBg: "#FCFCFC",
      headerColor: "#7A7A83"
      //rowHoverBg: '#FFFFFF',
    },
    DatePicker: {
      cellActiveWithRangeBg: "#F2F6FF"
    },
    Tooltip: {
      ...defaultTheme.components.Tooltip,
      colorBgSpotlight: "#27272A",
      colorText: "#FFFFFF"
    },
    Switch: {
      ...defaultTheme.components.Switch,
      colorPrimary: "#35BD29",
      colorPrimaryHover: "#006908"
    },
    Segmented: {
      ...defaultTheme.components.Segmented,
      colorBgLayout: "#F4F4F5",
      itemColor: "#27272A"
    }
  }
}

export const darkTheme = {
  token: {
    ...defaultTheme.token,

    colorPrimary: "#225AEA",
    colorLink: "#225AEA",
    colorSuccess: "#16895A",
    colorWarning: "#DF7009",
    colorError: "#D71313",
    colorErrorBorderHover: "#D71313",
    //black: '#000000',

    colorText: "#FCFCFC",
    colorTextBase: "#FCFCFC",
    colorTextHeading: "#FCFCFC",
    colorTextDescription: "#7A7A83",
    colorTextDisabled: "rgba(255, 255, 255, 0.26)",

    colorBgContainerDisabled: "rgba(255, 255, 255, 0.08)",

    colorBorder: "rgba(255, 255, 255, 0.12)",
    colorBorderSecondary: "rgba(255, 255, 255, 0.12)",

    //colorTextPlaceholder: '#7A7A83',
    colorBgLayout: "red",
    colorSplit: "rgba(255, 255, 255, 0.12)",

    bgPrimary: "rgba(34, 90, 234, 0.15)"
  },
  components: {
    ...defaultTheme.components,
    Layout: {
      ...defaultTheme.components.Layout,
      bodyBg: "#141414",
      headerBg: "#1D1D1D"
    },
    Card: {
      colorBgContainer: "#141414"
    },
    Popover: {
      colorBgElevated: "#1D1D1D"
    },
    Dropdown: {
      ...defaultTheme.components.Dropdown,
      colorBgElevated: "#1D1D1D",
      controlItemBgHover: "rgba(255, 255, 255, 0.08)",
      controlItemBgActiveHover: "red"
    },
    Button: {
      ...defaultTheme.components.Button,
      primaryShadow:
        "0 2px 1px 0px rgba(255, 255, 255, 0.24) inset, 0 4px 4px 0 rgba(20, 20, 20, 0.55)",

      defaultBg: "#292929",
      defaultBorderColor: "#292929",
      defaultHoverBorderColor: "#7A7A83",
      defaultHoverBg: "#292929",
      defaultHoverColor: "#FCFCFC",

      defaultActiveBorderColor: "#292929",
      defaultActiveBg: "#292929",
      defaultActiveColor: "#FCFCFC",

      textHoverBg: "#1D1D1D",

      colorPrimaryHover: "#1448CB",
      colorPrimaryActive: "#1448CB",
      colorBgTextActive: "transparent",
      colorBgTextHover: "transparent"
    },
    Input: {
      ...defaultTheme.components.Input,
      colorBgContainer: "#141414",

      hoverBg: "transparent",
      hoverBorderColor: "#225AEA",
      activeBorderColor: "#225AEA",
      colorIcon: "#7A7A83",
      colorIconHover: "#7A7A83",
      colorBgContainerDisabled: "rgba(255, 255, 255, 0.08)",
      colorTextDisabled: "rgba(255, 255, 255, 0.26)",
      errorActiveShadow: "0px 0px 0px 2px #700606"
    },
    InputNumber: {
      ...defaultTheme.components.InputNumber,
      colorBgContainer: "transparent",
      hoverBg: "transparent",
      hoverBorderColor: "#225AEA",
      activeBorderColor: "#225AEA",
      colorIcon: "#7A7A83",
      colorIconHover: "#7A7A83",
      colorBgContainerDisabled: "rgba(255, 255, 255, 0.08)",
      colorTextDisabled: "rgba(255, 255, 255, 0.26)"
    },
    Notification: {
      ...defaultTheme.components.Notification,
      colorBgElevated: "#1D1D1D",
      boxShadow: "1px 2px 4px 0 rgba(39, 39, 42, 0.08), 0 8px 25px 0 rgba(21, 30, 58, 0.12)"
    },
    Modal: {
      ...defaultTheme.components.Modal,
      contentBg: "#1D1D1D",
      colorBgMask: "rgba(0, 0, 0, 0.65)",
      titleColor: "#FFFFFF",
      colorText: "#7A7A83"
    },
    Tour: {
      colorBgElevated: "#1D1D1D"
    },
    Alert: {
      ...defaultTheme.components.Alert,
      colorInfo: "#225AEA",
      colorInfoBg: "rgba(34, 90, 234, 0.15)",
      colorInfoBorder: "rgba(34, 90, 234, 0.25)",

      colorWarningBg: "rgba(223, 112, 9, 0.15)",
      colorWarningBorder: "rgba(223, 112, 9, 0.25)",

      colorErrorBg: "rgba(215, 19, 19, 0.15)",
      colorErrorBorder: "rgba(215, 19, 19, 0.25)"
    },
    Select: {
      ...defaultTheme.components.Select,

      selectorBg: "#292929",
      colorBgElevated: "#1D1D1D",
      optionActiveBg: "rgba(255, 255, 255, 0.08)"
    },
    Table: {
      ...defaultTheme.components.Table,
      colorBgContainer: "#141414",
      headerBg: "#1D1D1D",
      borderColor: "none",
      headerColor: "#7A7A83",
      rowHoverBg: "#141414",
      rowSelectedBg: "rgba(34, 90, 234, 0.15)"
    },
    Pagination: {
      itemActiveBg: "none",
      itemActiveBgDisabled: "rgba(255, 255, 255, 0.08)",
      itemBg: "transparent"
    },
    Checkbox: {
      ...defaultTheme.components.Checkbox,
      colorBgContainer: "#141414"
    },
    DatePicker: {
      colorBgContainer: "#141414",
      cellActiveWithRangeBg: "#000E58"
    },
    Avatar: {
      groupBorderColor: "#141414"
    },
    Tooltip: {
      ...defaultTheme.components.Tooltip,
      colorBgSpotlight: "#27272A",
      colorText: "#FFFFFF"
    },
    Switch: {
      ...defaultTheme.components.Switch,
      colorPrimary: "#35BD29",
      colorPrimaryHover: "#006908"
    },
    Segmented: {
      ...defaultTheme.components.Segmented,
      colorBgLayout: "#141414",
      itemSelectedBg: "rgba(255, 255, 255, 0.08)",
      itemColor: "#FFFFFF"
    },
    Drawer: {
      //...defaultTheme.components.Drawer,
      colorBgElevated: "#141414",
      headerBg: "#1D1D1D"
    }
  }
}

const modalIconMap = {
  exclamation: "questionaire",
  question: "question_mark_modal",
  info: "warning_orange",
  error: "error_full",
  success: "success_full",
  confirm_delete: "confirm_delete_modal"
}

export const modalConfig = (iconType, width = 450) => ({
  width,
  icon: <Icon type={modalIconMap[iconType || "question"]} style={{ fontSize: 40 }} />,

  cancelButtonProps: {
    size: "large"
    // style: {width: 'calc(50% - 6px)',}
  },
  okButtonProps: {
    size: "large"
    // style: {width: 'calc(50% - 6px)',}
  }
})
